import { z } from 'zod'

export const tenantStatusSchema = z.enum(['preActive', 'trial', 'active', 'suspended'])
export type TenantStatus = z.infer<typeof tenantStatusSchema>

export const tenantStatusLabels = {
  preActive: '未契約',
  trial: 'トライアル',
  active: '契約中',
  suspended: '停止中',
}

export const tenantStatusOptions = Object.entries(tenantStatusLabels).map(([key, label]) => ({
  value: key,
  label,
}))

export const tenantStatusColors: Record<TenantStatus, string> = {
  preActive: 'yellow',
  trial: 'blue',
  active: 'green',
  suspended: 'gray',
}

// スキャンを利用可能かどうか判定（今後のステータス追加で漏れがでないように、Recordで管理している）
// TODO: 本来であればバックエンドのAPIでも細かくこれを判定すべきだが、現状はフロントエンドのみで判定しているので、APIを直で叩けば使えてしまう状態になっている
const isScanAvailableMapper: Record<TenantStatus, boolean> = {
  preActive: false,
  trial: true,
  active: true,
  suspended: false,
}
export function isScanAvailable(tenantStatus: TenantStatus) {
  return isScanAvailableMapper[tenantStatus]
}

// Scanditの本番ライセンスキーを使うべきかどうかを判定（今後のステータス追加で漏れがでないように、Recordで管理している）
const isProductionLicenseKeyMapper: Record<TenantStatus, boolean> = {
  preActive: false,
  trial: false,
  active: true,
  suspended: false,
}
export function isStatusForProductionLicenseKey(tenantStatus: TenantStatus) {
  return isProductionLicenseKeyMapper[tenantStatus]
}
